import { RouterModule } from '@angular/router';
import { CommonModule, NgIf } from '@angular/common';
import { Component, OnInit, Input, Inject, NgModule } from '@angular/core';
import { ItemToCategoryToComponent } from '../../models/item-to-category-to-component';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';

@Component({
    selector: 'pdp-text',
    templateUrl: './text.component.html',
    styleUrls: ['./text.component.scss'],
    imports: [NgIf, SanitizeHtmlPipe],
    standalone: true
})
export class TextComponent implements OnInit {

  private environment: any;

  @Input()
  public items: ItemToCategoryToComponent[];

  // set currentEnvironment in shop or offer appModule as provider.
  constructor(@Inject('currentEnvironment') environment) {
    this.environment = environment;
  }

  ngOnInit(): void {
  }
}

